import { FC } from 'react';

import { GiftCouponStatistics } from '@shared/api/giftCoupon/giftCoupon.interface';

interface Props {
  statistics: GiftCouponStatistics | null | undefined;
  pendingFallback: number;
}

export const RedemptionStatsBar: FC<Props> = ({ statistics, pendingFallback }) => {
  return (
    <div className="grid grid-cols-6 gap-3 p-4">
      <div className="rounded-lg bg-yellow-50 p-3 text-center">
        <p className="text-xl font-bold text-yellow-700">
          {statistics?.pending ?? pendingFallback}
        </p>
        <p className="text-xs text-yellow-600">발송 대기</p>
      </div>
      <div className="rounded-lg bg-green-50 p-3 text-center">
        <p className="text-xl font-bold text-green-700">{statistics?.delivered ?? '-'}</p>
        <p className="text-xs text-green-600">발송 완료</p>
      </div>
      <div className="rounded-lg bg-gray-100 p-3 text-center">
        <p className="text-xl font-bold text-gray-700">{statistics?.total ?? '-'}</p>
        <p className="text-xs text-gray-600">전체</p>
      </div>
      <div className="rounded-lg bg-red-50 p-3 text-center">
        <p
          className={`text-xl font-bold ${
            statistics?.blacklist && statistics.blacklist.length > 0
              ? 'text-red-700'
              : 'text-gray-400'
          }`}
        >
          {statistics?.blacklist?.length ?? 0}
        </p>
        <p className="text-xs text-red-600">중복 의심</p>
      </div>
      <div className="rounded-lg bg-orange-50 p-3 text-center">
        <p
          className={`text-xl font-bold ${
            statistics?.rejected ? 'text-orange-700' : 'text-gray-400'
          }`}
        >
          {statistics?.rejected ?? 0}
        </p>
        <p className="text-xs text-orange-600">발송불가</p>
      </div>
      <div className="rounded-lg bg-gray-50 p-3 text-center">
        <p
          className={`text-xl font-bold ${
            statistics?.canceled ? 'text-gray-700' : 'text-gray-400'
          }`}
        >
          {statistics?.canceled ?? 0}
        </p>
        <p className="text-xs text-gray-500">취소</p>
      </div>
    </div>
  );
};
